<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner :slider="slider"/>
    <Step :stepData="stepInfo"/>
    <FuncShow :funInfo="funInfo" style="background: #F4F7FF"/>
    <FuncBanner :funcData="funcData" style="background: #F4F7FF"/>
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncShow from '../widgets/func-show'
import Step from '../widgets/Step'
import FuncBanner from '../widgets/fun-banner'
import ContactFloat from '../widgets/contact-float.vue'

export default {
  components: {
    Navigator,
    FuncShow,
    ContactFloat,
    FuncBanner,
    SliderBanner,
    Step,
    Footer
  },
  data() {
    return {
      funcData: [
        {
          title: 'o2o商家端基础模块',
          subTitle: 'o2o商家端基础模块有店铺类型、店铺类型店铺审核、店铺管理、折扣设置、商品类目、打印机管理、打印模板、商家分账明细、分账微信账号设置等，支持电脑web和手机端，方便门店不同场景的使用。',
          carouseImg: require('@/assets/images/index/o2o-mall/banner2.png')
        },
        {
          title: 'o2o商家端分店管理',
          subTitle: 'o2o商家端分店管理可以添加分店的基本信息，店铺名称、店铺头像、所属分类、真实姓名、手机号、店铺地址、添加店铺折扣和管理店铺状态，批量管理解除和删除，支持电脑web和手机端管理，方便门店不同场景的使用。',
          carouseImg: require('@/assets/images/index/o2o-mall/banner3.png')
        }
      ],
      stepInfo: {
        title: '无限生成独立小程序',
        subTitle: '小程序一键生成，一键授权获取支付宝授权，即可打包，无需开发，智莺小程序助力商家流量销量双增长,提供一整套私域运营方案.轻松实现获客,转化,裂变,复购!',
        stepList: [
          {
            normalImg:'',
            choiceImg: '',
            stepTitle: '',
            showImg: require('@/assets/images/index/o2o-mall/img1.png')
          }
        ]
      },
      slider: {
        image: require('@/assets/images/index/o2o-mall/phone.png'),
        title: 'O2O商城',
        desc: "独家数字门店系统无限生成独立小程序，打造自己私域流量 "
      },
      funInfo: {
        title: 'O2O商城板块',
        list: [
          {
            title: '优惠券活动',
            img: require('@/assets/images/index/o2o-mall/img2.png'),
            text: '优惠券活动可以设置活动的方案，类型、使用门槛、支付满额、免减额、发送数量、领券人设置、领取张数数量限制、优惠券有效期时间和可使用的商品，可参与官方的活动或可自定义活动，支持电脑web和手机端管理，方便门店不同场景的使用。'
          },
          {
            title: '红包裂变',
            img: require('@/assets/images/index/o2o-mall/img3.png'),
            text: '裂变红包专为企业商户提供精准裂变获客方案,用户不仅可以通过扫码线下商家二维码消费领取支付优惠红包,还可以通过分享好友领取消费红包，轻松省钱，快速实现裂变吸粉,让企业商户摆脱传统营销模式,实现低成本裂变增长,助力企业商户低成本高效获客，支持电脑web和手机端管理，方便门店不同场景的使用。'
          },
          {
            title: '会员体系',
            img: require('@/assets/images/index/o2o-mall/img4.png'),
            text: '智莺提供完整会员管理系统,帮助商家轻松搭建会员体系,通过会员卡、会员等级、积分商城、签到、会员储值、付费会员等功能,轻松管理会员客户,培养会员忠诚,让会员持续活跃和复购。'
          },
          {
            title: '秒杀活动',
            img: require('@/assets/images/index/o2o-mall/img5.png'),
            text: '限时限量低价的促销方式，可设置指定商品在指定时间内低价限量销售，通过活动预热营造活动气氛，还可以开启预约增加参与门槛，最终达到引流转化的目的，支持电脑web和手机端管理，方便门店不同场景的使用。'
          },
          {
            title: 'o2o推手',
            img: require('@/assets/images/index/o2o-mall/img6.png'),
            text: 'o2o推手适用于商家，商家推手生活，尊享超多权益特权，有分享返佣、小店新开、自买返佣、信用特权、完善资料、全新设计、佣金提现、开店奖励、订单佣金等，o2o推手支持电脑web和手机端管理，方便门店不同场景的使用。'
          },
          {
            title: '小程序点餐',
            img: require('@/assets/images/index/o2o-mall/img7.png'),
            text: '点餐小程序对于餐饮行业来说非常有实用性,顾客到店无需排队就可以进行扫码点餐,节约顾客排队时间的同时,也减小了餐厅的人力物力,大大提升了工作效率。'
          },
          {
            title: 'o2o商家端员工管理',
            img: require('@/assets/images/index/o2o-mall/img8.png'),
            text: 'o2o商家端员工管理可以添加员工的基本信息，姓名、头像、职位名称、擅长技术、从业年数、员工加入时间、绑定手机号和登陆密码，管理职位权限，批量管理停用和删除，支持电脑web和手机端管理，方便门店不同场景的使用。'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
